import { jsxs as r, jsx as h } from "react/jsx-runtime";
import { E as a, S as m } from "./icons.types-0722eef5.js";
function d({ title: v, titleId: n, size: l, width: t, height: L, extended: i = !1, ...o }) {
  const c = i ? a : m, s = l ? c[l] : t || c[i ? "s" : "l"], Z = l ? c[l] : L || c[i ? "s" : "l"];
  return /* @__PURE__ */ r(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      width: s,
      height: Z,
      "aria-labelledby": n,
      ...o,
      children: [
        v ? /* @__PURE__ */ h("title", { id: n, children: v }) : null,
        /* @__PURE__ */ h(
          "path",
          {
            fill: "#2E3192",
            d: "M42 58h16c1.977 0 3.657-.446 5.052-1.223L42 44.219V58Zm25.66-7.79c.228-1.017.344-2.094.344-3.211v-5h-14.11l13.762 8.211M4.35 21.759A14.6 14.6 0 0 0 4 25v5h14.164L4.35 21.759ZM30 14H14c-1.963 0-3.632.44-5.02 1.206L30 27.746V14ZM9.043 56.826C10.42 57.57 12.066 58 14 58h16V44.324L9.043 56.826ZM4 42v5c0 1.151.122 2.26.363 3.303L18.283 42H4Zm59.115-26.745C61.71 14.457 60.006 14 58 14H42v13.851l21.115-12.596ZM68 30v-5c0-1.094-.113-2.149-.332-3.147L54.012 30H68Z"
          }
        ),
        /* @__PURE__ */ h(
          "path",
          {
            fill: "#E6E7E8",
            d: "m54.012 30 13.656-8.147c-.626-2.864-2.15-5.235-4.553-6.598L42 27.851V14h-2v18h28v-2H54.012ZM4 40v2h14.282L4.363 50.303c.661 2.855 2.231 5.199 4.68 6.523L30 44.324V58h2V40H4Zm64 0H40v18h2V44.219l21.052 12.558c2.421-1.348 3.964-3.705 4.604-6.565l-13.762-8.213L68 42v-2ZM30 14v13.746L8.98 15.206c-2.43 1.34-3.984 3.694-4.63 6.553L18.163 30H4v2h28V14h-2Z"
          }
        ),
        /* @__PURE__ */ h(
          "path",
          {
            fill: "#BE1E2D",
            d: "M40 32V14h-8v18H4v8h28v18h8V40h28v-8H40Z"
          }
        ),
        /* @__PURE__ */ h(
          "path",
          {
            fill: "#BE1E2D",
            d: "M25.938 30 5.888 18.031c-.43.64-.777 1.344-1.063 2.094L21.372 30h4.563M67.09 52.09 50.277 42h-4.656l20.313 12.219a9.998 9.998 0 0 0 1.156-2.125m-2.37-35.703L41.97 30l4.618.003L66.22 18.25c-.438-.797-.9-1.311-1.5-1.859ZM5.812 53.875c.45.685.991 1.306 1.61 1.844L30.062 42H25.5L5.813 53.875Z"
          }
        )
      ]
    }
  );
}
export {
  d as GbrUntedKingdom
};
